export const normalizeCommittees = (committees) =>
  committees.map((committee) => ({
    id: committee.committeeId,
    title: committee.committeeTitle,
    responsibleNames: committee.responsibleNames,
    // membership: committee.membership,
  }));
